import { render, staticRenderFns } from "./UserWidgets.vue?vue&type=template&id=3c77d572&"
import script from "./UserWidgets.vue?vue&type=script&lang=js&"
export * from "./UserWidgets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports